import React from "react";
import { Menu } from "antd";

import { shouldShowAdsNav, type AdsEnrollmentState } from "./ads-model";
import Ads from "./Ads";
import { RouteWrapper } from "../Auth";
import { UR_LoanOfficer, UR_LoanOfficerManager, UR_Owner } from "../State";

const { Item: MenuItem } = Menu;

export const ADS_ROUTE_PATH = "/app/ads";
export const ADS_ALLOWED_ROLES = [UR_LoanOfficerManager, UR_LoanOfficer, UR_Owner];

/**
 * Return the nav entry itself, or null, so Ant Menu receives a direct MenuItem
 * child instead of a custom wrapper component.
 */
export function renderAdsNavEntry(
  state: AdsEnrollmentState,
  entry: React.ReactNode,
): React.ReactNode {
  return shouldShowAdsNav(state) ? entry : null;
}

/** Desktop sidebar entry used directly by HomePage's Ant Menu. */
export function renderAdsDesktopNavEntry(
  state: AdsEnrollmentState,
  hasAllowedRole: boolean,
  icon: React.ReactNode,
): React.ReactNode {
  return renderAdsNavEntry(
    state,
    hasAllowedRole ? (
      <MenuItem key="ads" icon={icon}>
        Ads
      </MenuItem>
    ) : null,
  );
}

/** Mobile drawer entry used directly by HomePage. */
export function renderAdsMobileNavEntry(
  state: AdsEnrollmentState,
  hasAllowedRole: boolean,
  onNavigate: () => void,
): React.ReactNode {
  return renderAdsNavEntry(
    state,
    hasAllowedRole ? (
      <div className="nav" data-testid="ads-mobile-nav" onClick={onNavigate}>
        Ads
      </div>
    ) : null,
  );
}

/** Route element used directly inside HomePage's Switch. */
export function renderAdsRoute(): React.ReactElement {
  return (
    <RouteWrapper
      Component={Ads}
      roles={ADS_ALLOWED_ROLES}
      exact
      path={ADS_ROUTE_PATH}
    />
  );
}
